/**
 * Contract values shared with the server's `validateFeedbackPayload`. Anything here must stay in
 * step with server/routes/web/clientFeedback.js - these are not display strings.
 */

export const PROBLEM_CATEGORY_ID = 'problem';
export const IDEA_CATEGORY_ID = 'idea';
export const GENERAL_CATEGORY_ID = 'general';
export const PRODUCT_CATEGORY_ID = 'product';
export const CATEGORY_IDS = [PROBLEM_CATEGORY_ID, IDEA_CATEGORY_ID, GENERAL_CATEGORY_ID, PRODUCT_CATEGORY_ID];
export const POSITIVE_REACTION = 'positive';
export const NEUTRAL_REACTION = 'neutral';
export const NEGATIVE_REACTION = 'negative';
export const REACTION_VALUES = [POSITIVE_REACTION, NEUTRAL_REACTION, NEGATIVE_REACTION];
export const YES_ANSWER = 'yes';
export const NO_ANSWER = 'no';
export const YES_NO_VALUES = [YES_ANSWER, NO_ANSWER];